import React, { useEffect, useState } from 'react';
import { object } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { getRegion } from '../../../../utils/Region';
import { getTranslation } from '../../../../utils/getTranslation';
import { keyReplaceMultText } from '../../../../utils/Utils';
import { deleteEpisodeRequested } from '../../redux/episodeContainer.thunks';
import { setRecordingToPlay } from '../../../Player/actions/recordings/recordings.actions';
import { SUPPORTED_STREAM } from '../../../../constants';
import Utils from '../../../../utils/Utils';
import { pushSelectContentEvent } from 'utils/analytics/pushSelectContentEvent';
import Logger from 'services/logger';
import {
  setContentName,
  setContentType,
  showDeleteConfirmationModal,
  setDeleteCallback,
} from '../../../CarouselsDisplay/redux/actions/deleteConfirmationModal.actions';
import moment from 'moment';
import useMenuRedirect from '../../../Menu/hooks/useMenuRedirect';

import './styles.scss';
import { useNavigate } from 'react-router-dom';
import { useControlPin } from 'containers/CarouselsDisplay/components/ContentsCarouselContainer/components/PosterRecording/useControlPin';

export const PosterEpisode = ({ contentInfo }) => {
  //satates
  const [data, setData] = useState({});
  const translations = useSelector(
    state =>
      JSON.parse(state?.metadata?.translations || '{}')?.language?.[
        getRegion()
      ],
  );
  const { navigateToChannel, nodesSelected } = useMenuRedirect();
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { handleValidateContent } = useControlPin();

  //llaves asset
  const {
    content_data_option_button_delete, // btn eliminar
    content_playing_option_button_play, // btn play rojo
    playing_playerControls_toolbar_button_recorded, // grabado icon
    playing_playerControls_toolbar_button_recordingBlink, // grabando y por grabar icon
    content_data_recordings_placeholder, // placeholder img
  } = useSelector(state => state?.asset);

  //llaves text
  const PANELOPTIONS_DESCRIPTION_PROGRAMDURATION_LABEL =
    'panelOptions_description_programDuration_label'; // {@hrs}hr {@min}min (no da respuesta)
  const RIBBON_FORMAT_HOUR_LABEL = 'ribbon_format_hour_label'; // {@hrs} hr
  const RIBBON_FORMAT_MINUTES_LABEL = 'ribbon_format_minutes_label'; // {@min} min
  const PLAYING_PLAYERCONTROLS_TOOLBAR_BUTTON_RECORDED =
    'playing_playerControls_toolbar_button_recorded'; // Grabado
  const PLAYING_PLAYERCONTROLS_TOOLBAR_BUTTON_RECORDINGBLINK =
    'playing_playerControls_toolbar_button_recordingBlink'; // Grabando
  const RECORDING_NPVR_TORECORD_LABEL = 'recording_npvr_toRecord_label'; // Por grabar

  //otras contsantes
  const INGESTED = 'ingested'; // grabado
  const RECORDING = 'recording'; // grabando
  const SCHEDULED = 'scheduled'; // po grabar

  // funciones para el render

  // funcion para el formato de duración y fecha.
  const durationFormatt = () => {
    try {
      const dateFormatt = `${moment(data?.date * 1000).format('ll')}`; // formato de la fecha
      const durationCalculate = moment?.duration(data?.duration * 1000); // de milisegundos a hrs con min
      const hrs = durationCalculate?.hours(); // opteniendo hrs
      const min = durationCalculate?.minutes(); // opteniendo min

      const replaceTextHr = [
        {
          text: '{@hrs}',
          newText: hrs,
        },
      ];
      const replacetextMin = [
        {
          text: '{@min}',
          newText: min,
        },
      ];

      const hrsFotmatt = keyReplaceMultText(
        RIBBON_FORMAT_HOUR_LABEL,
        translations,
        replaceTextHr,
      );

      const minFormmat = keyReplaceMultText(
        RIBBON_FORMAT_MINUTES_LABEL,
        translations,
        replacetextMin,
      );

      const formatt = `${hrsFotmatt} ${minFormmat} ${dateFormatt}`;
      return formatt;
    } catch (e) {
      Logger.error(e);
      return '';
    }
  };

  // optener el texto segun el status
  const getTextStatus = () => {
    switch (data?.status) {
      case INGESTED: {
        return getTranslation(
          PLAYING_PLAYERCONTROLS_TOOLBAR_BUTTON_RECORDED,
          translations,
        );
      }

      case RECORDING: {
        return getTranslation(
          PLAYING_PLAYERCONTROLS_TOOLBAR_BUTTON_RECORDINGBLINK,
          translations,
        );
      }

      case SCHEDULED: {
        return getTranslation(RECORDING_NPVR_TORECORD_LABEL, translations);
      }

      default:
        return '';
    }
  };

  // optener el icono segun el status
  const getIconStatus = () => {
    if (data?.status === INGESTED) {
      return playing_playerControls_toolbar_button_recorded;
    }
    if (data?.status === RECORDING || data?.status === SCHEDULED) {
      return playing_playerControls_toolbar_button_recordingBlink;
    }

    return '';
  };

  // se debe mostrar el btn player
  const shouldShowThePlayButton = () => {
    if (data?.status === INGESTED || data?.status === RECORDING) {
      return true;
    }

    return false;
  };

  // funciones para obtener/formatear los datos

  const getDataEpisode = () => {
    const { channel, status, record_id, actions, pack_id } = contentInfo || {};
    const {
      date_begin,
      duration,
      ext_original_name,
      ext_eventimage_name,
      ext_episode_id,
    } = channel?.event || {};

    const dataPoster = {
      id: record_id,
      IsEvent: true,
      img: ext_eventimage_name || content_data_recordings_placeholder,
      name: channel?.event?.name || '',
      date: date_begin || '',
      duration: duration || '',
      numEpisode: ext_episode_id,
      status: status || '',
      deleteURl: actions?.delete || '',
      group_id: channel?.group_id || null,
      pack_id: pack_id || null,
      // metricas
      title: channel?.name || '',
      format_types: '',
      proveedor_code: '',
    };

    return dataPoster;
  };

  // funciones de eventos
  const handleDelete = () => {
    const options = {
      deleteURl: data?.deleteURl,
      idPoster: data?.id,
    };

    dispatch(deleteEpisodeRequested(options));
  };

  const showModalDetele = event => {
    event.stopPropagation();
    dispatch(setContentName(data?.name));
    dispatch(setContentType('episode'));
    dispatch(
      setDeleteCallback(() => {
        dispatch(handleDelete);
      }),
    );

    dispatch(showDeleteConfirmationModal);
  };

  const handleShowPlayerEvent = () => {
    try {
      let url = '';
      const { channel, actions } = contentInfo;
      const idURL = channel?.group_id;
      const actionsRecording = { ...actions };
      const item = {
        isRecording: true,
        channel_id: contentInfo?.channel?.id,
        liveref: contentInfo?.channel?.liveref,
        ...contentInfo?.channel?.event,
      };

      if (idURL) {
        const deviceSO = Utils.getDeviceOS();
        SUPPORTED_STREAM[deviceSO].forEach(value => {
          if (actionsRecording.play?.[value]) {
            url = actionsRecording.play?.[value];
          }
        });

        const recordingData = {
          item,
          url,
        };

        dispatch(
          setRecordingToPlay(recordingData, () => {
            navigate(`/${getRegion()}/watch/${channel?.group_id}`);
          }),
        );
      }
    } catch (error) {
      Logger.error(error);
    }
  };

  const selectAnalityc = event => {
    try {
      event.stopPropagation();
      pushSelectContentEvent(data, nodesSelected, 'episodios');
    } catch (error) {
      Logger.warn(error);
    }
  };

  const handleEventPoster = event => {
    event.stopPropagation();
    handleValidateContent(
      data,
      contentInfo,
      () => {
        if (data?.status === INGESTED) {
          // si esta en estatus grabado manda al player
          handleShowPlayerEvent();
        }
        if (data?.status === RECORDING) {
          // si esta en estatus grabando manda al canal en vivo
          navigateToChannel({ id: data?.group_id });
        }
      },
      'playRecordContent',
    );
  };

  useEffect(
    () => {
      const dataPoster = getDataEpisode();
      setData(dataPoster);
    },
    [contentInfo],
  );

  return (
    <div className="poster-episode" onClick={event => selectAnalityc(event)}>
      <figure className="poster-episode__figure">
        <img className="figure__img" src={data?.img} />
      </figure>
      <section className="poster-episode__inf">
        <section className="inf__description">
          <h3 className="description__title">{data?.name}</h3>
          <p className="description__time-episode">{durationFormatt()}</p>
          <div className="description__type">
            <img className="type__icon" src={getIconStatus()} />
            <p className="type__text">{getTextStatus()}</p>
          </div>
        </section>
        <section
          className={`inf__controllers ${
            shouldShowThePlayButton() ? '' : ' justify-content-end'
          }`}
        >
          {shouldShowThePlayButton() && (
            <button
              aria-label="play"
              type="button"
              onClick={event => handleEventPoster(event)}
              className="controllers__play"
              style={{
                backgroundImage: `url(${content_playing_option_button_play})`,
              }}
            />
          )}

          <button
            aria-label="delate"
            type="button"
            onClick={event => showModalDetele(event)}
            className="controllers__delete"
            style={{
              backgroundImage: `url(${content_data_option_button_delete})`,
            }}
          />
        </section>
      </section>
    </div>
  );
};

PosterEpisode.propTypes = {
  contentInfo: object,
};
